import header from './header';
import footer from './footer';
import home from './home';
import product from './product';
import news from './news';
import detail from './detail';
import one from './one';
import two from './two';
import three from './three';
import four from './four';
import five from './five';
import six from './six';
import contentUs from "./contentUs";
import useCases from './cases';
import aboutUs from './abtus';
import join from './join';

export default {
    language: '中文',
    // language: 'EN',
    ...header,
    ...footer,
    ...home,
    ...product,
    ...news,
    ...detail,
    ...one,
    ...two,
    ...three,
    ...four,
    ...five,
    ...six,
    ...contentUs,
    ...useCases,
    ...aboutUs,
    ...join,
};
